// Configuración para producción
// Configurado para: https://dashboard.doctorweb.top/

const PRODUCTION_CONFIG = {
  // URL base de tu API en producción
  API_BASE_URL: 'https://dashboard.doctorweb.top/api',
  
  // Configuración de la aplicación
  APP_NAME: 'CRM Sistema de Gestión',
  VERSION: '1.0.0',
  
  // Configuración de entorno
  NODE_ENV: 'production',
  
  // URLs específicas de la API
  ENDPOINTS: {
    TASKS: '/tasks',
    CLIENTS: '/clients',
    USERS: '/users',
    COMMENTS: '/comments',
    UPLOAD: '/upload',
    FILES: '/files'
  }
};

export default PRODUCTION_CONFIG;
